import React, { useState } from "react";
import {
    Select, FormControl, Box,
    RadioGroup, FormControlLabel, Radio,
    Typography
} from "@mui/material";
import Activity from "../PolicyDetails/Activity";


const GlobalActivityLog = ({
    selected_customer_list,
    customerId // This is needed to fetch notes for a specific customer
}) => {
    const [selectedPolicyId, setSelectedPolicyId] = useState("");
    const [selectedOption, setSelectedOption] = useState("All");

    const handleDropdownChange = (event) => {
        setSelectedPolicyId(event.target.value);
    };

    const handleRadioChange = (event) => {
        const newOption = event.target.value;
        setSelectedOption(newOption);

        // Reset selectedPolicyId when switching to "All"
        if (newOption === "All") {
            setSelectedPolicyId("");
        }
    };

    return (
        <>
            {/* Radio Button Group */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: 3 }}>
                <RadioGroup
                    row
                    value={selectedOption}
                    onChange={handleRadioChange}
                >
                    <FormControlLabel value="All" control={<Radio />} label="All" />
                    <FormControlLabel value="Policies" control={<Radio />} label="Policies" />
                </RadioGroup>
            </Box>

            {/* Show Native Select Dropdown only if "Policies" is selected */}
            {selectedOption === "Policies" && (
                <Box sx={{ display: 'flex' }}>
                    <FormControl fullWidth sx={{ mb: 2, width: '250px', ml: 3 }}>
                        {/* <InputLabel>Select Policy</InputLabel> */}
                         <Typography>Select Policy</Typography>
                        <Select
                            value={selectedPolicyId}
                            onChange={handleDropdownChange}
                            native
                        >
                            <option value="" disabled>Select a policy</option>
                            {selected_customer_list.map((policy) => (
                                <option key={policy.id} value={policy.policyNumber}>
                                    {policy.policyNumber}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            )}

            <Activity
                customerId={customerId}
                selectedOption={selectedOption}
                selectedPolicyId={selectedPolicyId}
            />
        </>
    );
}

export default GlobalActivityLog;